import React, { useState } from "react";
import FeedbackStepLayout from "../FeedbackStepLayout";

const Step4CodiInsight = ({ data, updateData, nextStep, prevStep }) => {
  const [input, setInput] = useState(data.invisibleWork || "");

  const handleNext = () => {
    if (!input.trim()) return alert("Tell Codi what invisible work mattered most!");
    updateData("invisibleWork", input.trim());
    nextStep();
  };

  return (
    <FeedbackStepLayout
      title="Almost there!"
      subtitle="What invisible work deserves more credit than it got?"
      step={4}
      totalSteps={5}
      onNext={handleNext}
      onBack={prevStep}
    >
      <div className="flex flex-col items-center mt-10">
        <textarea
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Type your thoughts here..."
          className="w-80 h-24 bg-stone-50 rounded-[10px] shadow-[inset_0px_4px_4px_0px_rgba(0,0,0,0.25)]
                     text-sm text-neutral-700 p-3 font-['Inter'] resize-none outline-none
                     focus:ring-2 focus:ring-blue-400 focus:bg-white transition-all"
        />
      </div>
    </FeedbackStepLayout>
  );
};

export default Step4CodiInsight;
